import { ENVIRONMENT, DEVELOPMENT } from 'constants';
import HyperDX from '@hyperdx/browser';

const skipHyperDX = () => {
  return DEVELOPMENT || new URLSearchParams(window.location.search).get('skip_hdx') === 'true';
};

export const initHyperDX = () => {
  if (skipHyperDX()) {
    console.debug('skipping initHyperDX');
    return;
  }

  HyperDX.init({
    url: 'https://hdx.insurgate.com/ingest',
    apiKey: 'c82c8b1e-361f-4907-bcdf-686d34874d04',
    service: `ig-${ENVIRONMENT}`,
    tracePropagationTargets: [/(api|paul)\.insurgate(-staging|-validation)?\.com/i],
    consoleCapture: true,
    advancedNetworkCapture: true,
    maskAllInputs: false,
    maskAllText: false,
  });
};

export const identifyHyperDX = (user) => {
  if (skipHyperDX()) {
    console.debug('skipping identifyHyperDX');
    return;
  }

  HyperDX.setGlobalAttributes({
    userId: user.id,
    userEmail: user.email,
    userName: `${user.first_name} ${user.last_name}`,
    teamName: user.account.name,
  });
};

export const stopNetHyperDX = () => {
  if (skipHyperDX()) {
    console.debug('skipping stopNetHyperDX');
    return;
  }

  HyperDX.disableAdvancedNetworkCapture();
};

export const startNetHyperDX = () => {
  if (skipHyperDX()) {
    console.debug('skipping startNetHyperDX');
    return;
  }

  HyperDX.enableAdvancedNetworkCapture();
};
